import { PhysiciansView } from "@/features/admin/physicians/components/PhysiciansView";

export function PhysiciansPage() {
  return <PhysiciansView />;
}
